/** Which tracking team index (0/1) is home on a game: its identity's
 *  game_facts.tracking_home_index, and 1 where none is recorded — the
 *  server's rule (app/utils/football/direction.home_index). The match
 *  page, its panels, telestration and the Lab dashboards (both trees) read
 *  it here. CanvasWorkspace's club team does not: it refuses on an
 *  unrecorded index instead. */
export function homeIndexOf(
  identity: { tracking_home_index?: number | null } | null | undefined,
): 0 | 1 {
  return identity?.tracking_home_index === 0 ? 0 : 1
}
